import { Page, Text, View } from "@react-pdf/renderer";
import React from "react";
import { styles } from "../../style";

const Page3 = ({ data }) => {
  return (
    <Page size="A4" style={styles.page}>
      <View style={styles.spaceY}>
        <View style={styles.spaceX}>
          <Text>3.8.</Text>
          <Text style={styles.text}>
            М Мюзик Дистрибюшн нь Гэрээний 3.3-т заасан орлогыг хуваарилахдаа
            Эрх олгогчоос ирүүлсэн төлбөрийн баримтыг хүлээн авсан өдрөөс хойш
            ажлын 5 хоногийн дотор Эрх олгогчийн{" "}
            <Text style={styles.textBold}>
              {data?.bank_account?.bank?.name ?? " ................"}
            </Text>{" "}
            банкны{" "}
            <Text style={styles.textBold}>
              {data?.bank_account?.number ?? " ................"}
            </Text>{" "}
            тоот дансанд шилжүүлнэ.
          </Text>
        </View>
      </View>
      <View style={styles.header}>
        <Text
          style={[
            styles.title,
            styles.textBold,
            { letterSpacing: 0.2, marginTop: 8 },
          ]}
        >
          ДӨРӨВ. ТАЛУУДЫН ЭРХ ҮҮРЭГ
        </Text>
      </View>
      <View style={styles.spaceY}>
        <View style={styles.spaceX}>
          <Text>4.1.</Text>
          <Text style={styles.text}>Эрх олгогчийн эрх</Text>
        </View>
        <View style={styles.subListItem}>
          <View style={styles.spaceX}>
            <Text>4.1.1. {""}</Text>
            <Text style={styles.subtext}>
              М Мюзик Дистрибюшнээс гэрээнд заасан төлбөрийг хугацаандаа
              төлөхийг шаардах;
            </Text>
          </View>
        </View>
        <View style={styles.subListItem}>
          <View style={[styles.spaceX, { paddingTop: 8 }]}>
            <Text>4.1.2. {""}</Text>
            <Text style={styles.subtext}>
              М Мюзик Дистрибюшний энэхүү гэрээнд заасан үйл ажиллагаа нь хууль
              тогтоомжид нийцэж байгаа эсэхэд хяналт тавих;
            </Text>
          </View>
        </View>
        <View style={styles.subListItem}>
          <View style={styles.spaceX}>
            <Text>4.1.3. {""}</Text>
            <Text style={styles.subtext}>
              Уран бүтээлийг нийтэд түгээсэн, түрээсэлсэн талаарх борлуулалтын
              мэдээг <Text style={styles.link}>www.mmusic.mn</Text> рүү өөрийн
              эрхээр нэвтэрч шалгах;
            </Text>
          </View>
        </View>
        <View style={styles.subListItem}>
          <View style={styles.spaceX}>
            <Text>4.1.4. {""}</Text>
            <Text style={styles.subtext}>
              М Мюзик Дистрибюшн нь уран бүтээлийг Эрх олгогчийн
              зөвшөөрөлгүйгээр, эсхүл нэр хүндэд нь хохирол учруулахуйц байдлаар
              аливаа арга, хэлбэрээр хувиргах, өөрчлөх, гажуудуулахыг хориглох;
            </Text>
          </View>
        </View>
        <View style={styles.subListItem}>
          <View style={styles.spaceX}>
            <Text>4.1.5. {""}</Text>
            <Text style={styles.subtext}>
              М Мюзик Дистрибюшнээс Гэрээнд заасан үйлчилгээг үзүүлэхдээ
              бүтээлийн эх файлын аюулгүй байдлыг хангаж ажиллахыг шаардах;
            </Text>
          </View>
        </View>
        <View style={styles.subListItem}>
          <View style={styles.spaceX}>
            <Text>4.1.6. {""}</Text>
            <Text style={styles.subtext}>
              М Мюзик Дистрибюшнээс гэрээ болон бусад хууль тогтоомжид заасан
              үүргийг биелүүлэхийг шаардах.
            </Text>
          </View>
        </View>
        <View style={styles.spaceX}>
          <Text>4.2.</Text>
          <Text style={styles.text}>Эрх олгогчийн үүрэг</Text>
        </View>
        <View style={styles.subListItem}>
          <View style={styles.spaceX}>
            <Text>4.2.1. {""}</Text>
            <Text style={styles.subtext}>
              Гэрээ байгуулагдсанаас хойш 7 хоногийн дотор өөрийн уран бүтээлийг
              М Мюзик Дистрибюшнд хүлээлгэн өгөх бөгөөд гэрээний хүчинтэй
              хугацаанд гаргасан шинэ уран бүтээл бүрийг www.mmusic.mn руу
              нэвтрэн орж байршуулах эсхүл{" "}
              <Text style={styles.link}>contact@mmusic.mn</Text> хаягаар илгээх;
            </Text>
          </View>
        </View>
        <View style={styles.subListItem}>
          <View style={styles.spaceX}>
            <Text>4.2.2. {""}</Text>
            <Text style={styles.subtext}>
              Гэрээний 3.7-д заасны дагуу И-баримтаа шивж мэдэгдэх;
            </Text>
          </View>
        </View>
        <View style={styles.subListItem}>
          <View style={styles.spaceX}>
            <Text>4.2.3. {""}</Text>
            <Text style={styles.subtext}>
              Эрх олгогч нь энэхүү гэрээний ашиг сонирхолтой зөрчилдөх аливаа
              гэрээ байгуулаагүй боловч гуравдагч этгээдтэй байгуулсан гэрээгээ
              зөрчсөний улмаас үүсэх хохирол, аливаа хариуцлагаас М Мюзик
              Дистрибюшнийг чөлөөлж, хохирлыг арилгах;
            </Text>
          </View>
        </View>
        <View style={styles.subListItem}>
          <View style={styles.spaceX}>
            <Text>4.2.4. {""}</Text>
            <Text style={styles.subtext}>
              Уран бүтээлийн зохиогчийн эрх, түүнд хамаарах онцгой эрхтэй
              холбоотойгоор аливаа гуравдагч этгээд /дуу, ая зохиогч, хамтын
              удирдлагын байгууллага... зэрэг/-ээс гомдол, маргаан гаргасан
              тохиолдолд Эрх олгогч нь М Мюзик Дистрибюшнийг уг маргаан,
              хариуцлагаас ангид байлгана.
            </Text>
          </View>
        </View>
        <View style={styles.subListItem}>
          <View style={styles.spaceX}>
            <Text>4.2.5. {""}</Text>
            <Text style={styles.subtext}>
              Хэрэв Эрх олгогч нь аливаа зохиогчийн эрхийг хамгаалах хамтын
              удирдлагын байгууллагын гишүүн биш ба гэрээний хугацаа дуусахаас
              өмнө аль нэг хамтын удирдлагын байгууллагад гишүүнээр элсэх бол
              энэ талаар М Мюзик Дистрибюшнд урьдчилан мэдэгдэх;
            </Text>
          </View>
        </View>
        <View style={styles.subListItem}>
          <View style={styles.spaceX}>
            <Text>4.2.6. {""}</Text>
            <Text style={styles.subtext}>
              Гэрээ болон холбогдох хууль тогтоомжид заасан бусад үүрэг.
            </Text>
          </View>
        </View>
        <View style={styles.spaceX}>
          <Text>4.3.</Text>
          <Text style={styles.text}>М Мюзик Дистрибюшний эрх</Text>
        </View>
        <View style={styles.subListItem}>
          <View style={styles.spaceX}>
            <Text>4.3.1. {""}</Text>
            <Text style={styles.subtext}>
              М Мюзик Дистрибюшн нь Гэрээ байгуулагдсанаас хойш 7 хоногийн дотор
              Эрх олгогчийг уран бүтээлээ{" "}
              <Text style={styles.link}>contact@mmusic.mn</Text> илгээхийг
              шаардах;
            </Text>
          </View>
        </View>
      </View>
    </Page>
  );
};

export default Page3;
